import { PerformanceEventRecorder, PerformanceEventRecorderOptions } from "./performance-event-recorder";

/**
 * Function decorator to track performace of a function call. Use with @measurePerformance("descriptive_name")
 * PerformanceMeasureService must be injected in class. Event recorder will be named `${name}`
 *
 * See https://www.typescriptlang.org/docs/handbook/decorators.html for more information on decorators.
 *
 * @param {string} name Name of performance event recorder
 * @param {PerformanceEventRecorderOptions} options Optional options to add to performance event
 */
export function MeasurePerformance(name: string, options?: PerformanceEventRecorderOptions): Function {
  return function (target: Object, propertyKey: string, descriptor: PropertyDescriptor): void {
    const originalFunc: any = descriptor.value;
    descriptor.value = function (...args: any[]): void {
      const performanceEvent: PerformanceEventRecorder =
        // tslint:disable-next-line:no-invalid-this
        this.performanceMeasure.getOrCreateEventRecorder(`${name}`, options || {});
      performanceEvent.start();
      try {
        // tslint:disable-next-line:no-invalid-this
        let result = originalFunc.apply(this, args);
        if (result && result.then) {
          return result
            .then((result: any) => {
              performanceEvent.success();
              return result;
            })
            .catch((error: any) => {
              performanceEvent.failure(error);
              throw error;
            });
        }
        performanceEvent.success();
        return result;
      } catch (error) {
        performanceEvent.failure(error);
        throw error;
      }
    };
  };
}
